import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { MasterLayout } from "../layout/MasterLayout";
import SettingRoutes from "../pages/settings";
import ActivityRoutes from "../pages/activity";
import ContactRoutes from "../pages/contact";
import EmailIndex from "../pages/email";
import TicketIndex from "../pages/ticket";
import DashboardRoutes from "../pages/dashboard";
import CampaignRoutes from "../pages/campaign";
import ChatRoutes from "../pages/chat";
import PhoneRoutes from "../pages/phone/Index";
import UserRoute from "../pages/users";
import AccountInfo from "../components/contact/accounts/AccountInfo";
import ContactInfo from "../components/contact/contact/ContactInfo";
import Reports from "../pages/report/Index";
import Profile from "../pages/profile/Profile";
import { useEffect, useState } from "react";
import { useWebSocket, WebSocketProvider } from "../context/WebSocketContext";
import Callhistory from "../pages/callhistory/index"
import ConversationsPage from "../pages/conversations";
import { UserProvider } from "../context/UserContext";
import { ChatProvider } from "../context/ChatContext";
import SocialMediaRoutes from "../pages/socialMedia";
import { PlanProvider } from "../context/PlanContext";
const PrivateRoutes = () => {
  const [permissionList, setPermissionList] = useState<any>([]);

  const permissionToShow = localStorage.getItem("user-token");
  const location = useLocation();
  console.log("chat changes log")

  useEffect(() => {
    const gettingLocation = location.pathname;
    const first_word = gettingLocation.split("/")[1];
    const second_word = gettingLocation.split("/")[2];
    localStorage.setItem("first_word", first_word);

    if (first_word === "ticket") {
      sessionStorage.removeItem("selectedFilter");
      sessionStorage.removeItem("selectedFilters");
      sessionStorage.removeItem("selectStarredFilters");
      sessionStorage.removeItem("selectStaredFilterAndValue");
      sessionStorage.removeItem("selectSentFilters");
      sessionStorage.removeItem("selectedSentFilterAndValue");
      sessionStorage.removeItem("inboxInitial_selectedTeamId");
      sessionStorage.removeItem("inboxInitial_currentPage");
      sessionStorage.removeItem("inboxInitial_perPage");
      sessionStorage.removeItem("selectedCampaignFilterAndValue");
      sessionStorage.removeItem("campaignCurrentPage");
      sessionStorage.removeItem("selectedOptionCampign");
      sessionStorage.removeItem("selectedCampaignId");
      sessionStorage.removeItem("outwardLeadButton");
      sessionStorage.removeItem("selectedCampignFilters");
    }
    if (first_word === "email") {
      sessionStorage.removeItem("selectedTicketFilters");
      sessionStorage.removeItem("selectedFilterAndValue");
      sessionStorage.removeItem("ticketCurrentPage");
      sessionStorage.removeItem("selectedTeamId");
      sessionStorage.removeItem("selectedWorkFlow");
      sessionStorage.removeItem("selectedOption");
      sessionStorage.removeItem("selectedCampaignFilterAndValue");
      sessionStorage.removeItem("campaignCurrentPage");
      sessionStorage.removeItem("selectedOptionCampign");
      sessionStorage.removeItem("selectedCampaignId");
      sessionStorage.removeItem("outwardLeadButton");
      sessionStorage.removeItem("selectedCampignFilters");
    }
    if (first_word === "campaign") {
      sessionStorage.removeItem("ticketCurrentPage");
      sessionStorage.removeItem("selectedTeamId");
      sessionStorage.removeItem("selectedWorkFlow");
      sessionStorage.removeItem("selectedFilter");
      sessionStorage.removeItem("selectStarredFilters");
      sessionStorage.removeItem("selectStaredFilterAndValue");
      sessionStorage.removeItem("selectSentFilters");
      sessionStorage.removeItem("selectedSentFilterAndValue");
      sessionStorage.removeItem("inboxInitial_selectedTeamId");
      sessionStorage.removeItem("inboxInitial_currentPage");
      sessionStorage.removeItem("inboxInitial_perPage");
      sessionStorage.removeItem("selectedTicketFilters");
      sessionStorage.removeItem("selectedOption");
    }
     if (first_word === "activity" && second_word === "recent") {
      // Preserve RecentTasks sessionStorage keys while clearing others
      const recentTabIndex = sessionStorage.getItem("recentTabIndex");
      const recentTasksCurrentPage = sessionStorage.getItem("recentTasksCurrentPage");
      const recentTasksScrollPosition = sessionStorage.getItem("recentTasksScrollPosition");
      const lastViewedRecent = sessionStorage.getItem("lastViewedRecent");
      
      sessionStorage.clear();
      
      // Restore RecentTasks sessionStorage values
      if (recentTabIndex != null) sessionStorage.setItem("recentTabIndex", recentTabIndex);
      if (recentTasksCurrentPage != null) sessionStorage.setItem("recentTasksCurrentPage", recentTasksCurrentPage);
      if (recentTasksScrollPosition != null) sessionStorage.setItem("recentTasksScrollPosition", recentTasksScrollPosition);
      if (lastViewedRecent != null) sessionStorage.setItem("lastViewedRecent", lastViewedRecent);
    }
    if (first_word === "activity" && second_word === "active") {
      // Preserve TodayTasks sessionStorage keys while clearing others
      const todayTabIndex = sessionStorage.getItem("todayTabIndex");
      const todaysTaskCurrentPage = sessionStorage.getItem("todaysTaskCurrentPage");
      const todaysTasksScrollPosition = sessionStorage.getItem("todaysTasksScrollPosition");
      const lastViewedToday = sessionStorage.getItem("lastViewedToday");
      
      sessionStorage.clear();
      
      // Restore TodayTasks sessionStorage values
      if (todayTabIndex != null) sessionStorage.setItem("todayTabIndex", todayTabIndex);
      if (todaysTaskCurrentPage != null) sessionStorage.setItem("todaysTaskCurrentPage", todaysTaskCurrentPage);
      if (todaysTasksScrollPosition != null) sessionStorage.setItem("todaysTasksScrollPosition", todaysTasksScrollPosition);
      if (lastViewedToday != null) sessionStorage.setItem("lastViewedToday", lastViewedToday);
    }
    if (first_word === "activity" && second_word === "unassigned") {
      // Preserve UnassignedTasks sessionStorage keys while clearing others
      const unassignedTabIndex = sessionStorage.getItem("unassignedTabIndex");
      const selectedUnassignedFiltersTicket = sessionStorage.getItem("selectedUnassignedFilters_ticket");
      const selectedUnassignedFiltersEmail = sessionStorage.getItem("selectedUnassignedFilters_email");
      const unassignedTicketPaginationPageSize = sessionStorage.getItem("unassigned_ticket_pagination_pageSize");
      const unassignedEmailPaginationPageSize = sessionStorage.getItem("unassigned_email_pagination_pageSize");
      const unassignedTicketPaginationCurrentPage = sessionStorage.getItem("unassigned_ticket_pagination_currentPage");
      const unassignedEmailPaginationCurrentPage = sessionStorage.getItem("unassigned_email_pagination_currentPage");
      const unassignedTicketsScrollPosition = sessionStorage.getItem("unassignedTicketsScrollPosition");
      const lastViewedUnassigned = sessionStorage.getItem("lastViewedUnassigned");
      
      sessionStorage.clear();
      
      // Restore UnassignedTasks sessionStorage values
      if (unassignedTabIndex != null) sessionStorage.setItem("unassignedTabIndex", unassignedTabIndex);
      if (selectedUnassignedFiltersTicket != null) sessionStorage.setItem("selectedUnassignedFilters_ticket", selectedUnassignedFiltersTicket);
      if (selectedUnassignedFiltersEmail != null) sessionStorage.setItem("selectedUnassignedFilters_email", selectedUnassignedFiltersEmail);
      if (unassignedTicketPaginationPageSize != null) sessionStorage.setItem("unassigned_ticket_pagination_pageSize", unassignedTicketPaginationPageSize);
      if (unassignedEmailPaginationPageSize != null) sessionStorage.setItem("unassigned_email_pagination_pageSize", unassignedEmailPaginationPageSize);
      if (unassignedTicketPaginationCurrentPage != null) sessionStorage.setItem("unassigned_ticket_pagination_currentPage", unassignedTicketPaginationCurrentPage);
      if (unassignedEmailPaginationCurrentPage != null) sessionStorage.setItem("unassigned_email_pagination_currentPage", unassignedEmailPaginationCurrentPage);
      if (unassignedTicketsScrollPosition != null) sessionStorage.setItem("unassignedTicketsScrollPosition", unassignedTicketsScrollPosition);
      if (lastViewedUnassigned != null) sessionStorage.setItem("lastViewedUnassigned", lastViewedUnassigned);
    }
    if (first_word === "activity" && second_word === "sl-breached") {
      // Preserve SLBreachedTasks sessionStorage keys while clearing others
      const slBreachedTabIndex = sessionStorage.getItem("slBreachedTabIndex");
      const slBreachFilterValuesTickets = sessionStorage.getItem("slBreachFilterValues_tickets");
      const slBreachFilterValuesEmails = sessionStorage.getItem("slBreachFilterValues_emails");
      const slBreachTicketsPaginationPageSize = sessionStorage.getItem("slbreach_tickets_pagination_pageSize");
      const slBreachEmailsPaginationPageSize = sessionStorage.getItem("slbreach_emails_pagination_pageSize");
      const slBreachTicketsPaginationCurrentPage = sessionStorage.getItem("slbreach_tickets_pagination_currentPage");
      const slBreachEmailsPaginationCurrentPage = sessionStorage.getItem("slbreach_emails_pagination_currentPage");
      const slBreachWorkflow_tickets = sessionStorage.getItem("slBreachWorkflow_tickets");
      const slBreachWorkflow_emails = sessionStorage.getItem("slBreachWorkflow_emails");
      const slBreachedTasksScrollPosition = sessionStorage.getItem("slBreachedTasksScrollPosition");
      const lastViewedSLBreached = sessionStorage.getItem("lastViewedSLBreached");
      
      sessionStorage.clear();
      
      // Restore SLBreachedTasks sessionStorage values
      if (slBreachedTabIndex != null) sessionStorage.setItem("slBreachedTabIndex", slBreachedTabIndex);
      if (slBreachFilterValuesTickets != null) sessionStorage.setItem("slBreachFilterValues_tickets", slBreachFilterValuesTickets);
      if (slBreachFilterValuesEmails != null) sessionStorage.setItem("slBreachFilterValues_emails", slBreachFilterValuesEmails);
      if (slBreachTicketsPaginationPageSize != null) sessionStorage.setItem("slbreach_tickets_pagination_pageSize", slBreachTicketsPaginationPageSize);
      if (slBreachEmailsPaginationPageSize != null) sessionStorage.setItem("slbreach_emails_pagination_pageSize", slBreachEmailsPaginationPageSize);
      if (slBreachTicketsPaginationCurrentPage != null) sessionStorage.setItem("slbreach_tickets_pagination_currentPage", slBreachTicketsPaginationCurrentPage);
      if (slBreachEmailsPaginationCurrentPage != null) sessionStorage.setItem("slbreach_emails_pagination_currentPage", slBreachEmailsPaginationCurrentPage);
      if (slBreachWorkflow_tickets != null) sessionStorage.setItem("slBreachWorkflow_tickets", slBreachWorkflow_tickets);
      if (slBreachWorkflow_emails != null) sessionStorage.setItem("slBreachWorkflow_emails", slBreachWorkflow_emails);
      if (slBreachedTasksScrollPosition != null) sessionStorage.setItem("slBreachedTasksScrollPosition", slBreachedTasksScrollPosition);
      if (lastViewedSLBreached != null) sessionStorage.setItem("lastViewedSLBreached", lastViewedSLBreached);
    }
    if (
      first_word === "dashboard" ||
      first_word === "reports" ||
      first_word === "profile" ||
      first_word === "settings" ||
      first_word === "contact" ||
      first_word === "users" ||
      first_word === "chat"
    ) {
      // Preserve scroll position keys so account/contact list scroll survives when user returns
      const accountScroll = sessionStorage.getItem("accountCardsScrollPosition");
      const lastViewedAccount = sessionStorage.getItem("lastViewedAccount");
      const contactScroll = sessionStorage.getItem("contactCardsScrollPosition");
      const lastViewedContact = sessionStorage.getItem("lastViewedContact");
      sessionStorage.clear();
      if (accountScroll != null) sessionStorage.setItem("accountCardsScrollPosition", accountScroll);
      if (lastViewedAccount != null) sessionStorage.setItem("lastViewedAccount", lastViewedAccount);
      if (contactScroll != null) sessionStorage.setItem("contactCardsScrollPosition", contactScroll);
      if (lastViewedContact != null) sessionStorage.setItem("lastViewedContact", lastViewedContact);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (permissionToShow) {
      const parsedPermission = JSON.parse(permissionToShow); // Parse the JSON string
      const teamPermissions = parsedPermission?.teams[0];

      // Find the key that you need dynamically
      const dynamicKey =
        Object.keys(teamPermissions).find((key) =>
          key.includes("module_permissions")
        ) || Object.keys(teamPermissions)[0];

      const permissionListValue = teamPermissions[dynamicKey] || []; // Ensure permissionListValue is an array
      setPermissionList(permissionListValue);
    }
  }, [permissionToShow]);

  const hasPermission = (permission) =>
    Array.isArray(permissionList) && permissionList.includes(permission);



  useEffect(() => {
    // Track if we're currently on a page that should have the script
    const shouldHaveScript =
      location.pathname.startsWith('/settings/') &&
      !location.pathname.includes('settings/telephony/');

    if (shouldHaveScript) {
      // Only load the script if it's not already loaded
      if (!(window as any).botgo) {
        const botgoSettings = {
          appId: "d7058e43b16fb05b07900fcb1c8c091c",
          "botgo-primary-color": "",
          "botgo-bot-bubble-color": "",
          "botgo-header-height": "60px",
          initiallyShow: false,
        };

        const s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.id = "botgo-script";
        const ts = Math.round(Date.now() / 1000);
        s.src = "https://botgo.io/chatbotPluginDev/embedd.js?t" + ts;

        // Add error handling
        s.onerror = () => {
          console.error('Failed to load Botgo script');
          if (s.parentNode) {
            s.parentNode.removeChild(s);
          }
        };

        const h = document.getElementsByTagName("head")[0];
        h.appendChild(s);
        (window as any).botgo = (window as any).botgo || {};
        (window as any).botgo._globals = botgoSettings;
      }
    } else {
      // Clean up if we're on a page that shouldn't have the script
      const cleanupBotgo = () => {
        // Remove the script tag if it exists
        const script = document.getElementById('botgo-script');
        if (script?.parentNode) {
          script.parentNode.removeChild(script);
        }

        // Remove all botgo iframes
        const botgoIframes = document.querySelectorAll('iframe[src*="botgo.io"], iframe[id^="botgo"], iframe[class*="botgo"]');
        botgoIframes.forEach(iframe => {
          if (iframe?.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }
        });

        // Remove any botgo container divs
        const botgoContainers = document.querySelectorAll('div[id^="botgo"], div[class*="botgo"]');
        botgoContainers.forEach(container => {
          if (container?.parentNode) {
            container.parentNode.removeChild(container);
          }
        });

        // Clean up global botgo object and any related globals
        const botgoGlobals = ['botgo', 'botgoSettings', 'botgoWidget'];
        botgoGlobals.forEach(global => {
          if ((window as any)[global]) {
            try {
              delete (window as any)[global];
            } catch (e) {
              console.warn(`Failed to remove global ${global}:`, e);
            }
          }
        });
      };

      // Clean up on next tick to avoid race conditions
      const cleanupTimer = setTimeout(cleanupBotgo, 0);

      return () => clearTimeout(cleanupTimer);
    }

    // Cleanup is handled by the effect's cleanup function
  }, [location.pathname]);

  const isFreeOrFreemium = localStorage.getItem("planName") === "Free" || localStorage.getItem("planName") === "Freemium";
  return (
    <UserProvider>
      <PlanProvider>
        <ChatProvider>

          <WebSocketProvider>
            <Routes>
              <Route element={<MasterLayout />}>

                {!isFreeOrFreemium ?
                  <>
                    {hasPermission("dashboard:enable") && (
                      <Route path="dashboard/*" element={<DashboardRoutes />} />
                    )}
                    {hasPermission("campaigns:enable") && (
                      <Route path="campaign/*" element={<CampaignRoutes />} />
                    )}
                    {hasPermission("customers:enable") && (
                      <Route path="contact/*" element={<ContactRoutes />} />
                    )}
                    {hasPermission("ticket:enable") && (
                      <Route path="ticket/*" element={<TicketIndex />} />
                    )}
                    {hasPermission("email:enable") && (
                      <Route path="email/*" element={<EmailIndex />} />
                    )}
                    {hasPermission("users:enable") && (
                      <Route path="users/*" element={<UserRoute />} />
                    )}
                    {/* {hasPermission("activity:enable") &&  */}
                    <Route path="activity/*" element={<ActivityRoutes />} />
                    {hasPermission("settings:enable") && (
                      <Route path="settings/*" element={<SettingRoutes />} />
                    )}

                    <Route path="chat/*" element={<ConversationsPage />} />


                    {hasPermission("reports:enable") && (
                      <Route path="reports/*" element={<Reports />} />
                    )}
                    <Route path="/*" element={<PhoneRoutes />} />
                    {hasPermission("customers:enable") && (
                      <Route path="/customer/info/:id" element={<AccountInfo />} />
                    )}
                    {hasPermission("customers:enable") && (
                      <Route path="/account/info/:id" element={<ContactInfo />} />
                    )}
                    {/* SocialMedia(youtube) */}
                    <Route path="social-media/*" element={<SocialMediaRoutes />} />


                    {!hasPermission("dashboard:enable") && (
                      <Route path="*" element={<Navigate to="/not-authorized" />} />
                    )}
                  </>
                  :
                  <>
                    <Route path="reports/*" element={<Reports />} />
                    <Route path="dashboard/*" element={<DashboardRoutes />} />
                    <Route path="campaign/*" element={<CampaignRoutes />} />
                    <Route path="settings/*" element={<SettingRoutes />} />
                    <Route path="users/*" element={<UserRoute />} />

                  </>
                }
                <Route path="user-profile" element={<Profile />} />
                <Route path="/call-history" element={<Callhistory />} />
              </Route>
            </Routes>
          </WebSocketProvider>

        </ChatProvider>
      </PlanProvider>
    </UserProvider>
  );
};

export { PrivateRoutes };